import { Link, useLocation } from 'react-router-dom';
import { Dashboard, Document, Receipt, Chat, Settings, UserMultiple } from '@carbon/icons-react';
import { useAuth } from '@/contexts/AuthContext';

const navItems = [
  { to: '/dashboard', label: 'Overview', icon: Dashboard },
  { to: '/contracts', label: 'Contracts', icon: Document },
  { to: '/invoices', label: 'Invoices', icon: Receipt },
  { to: '/contact-review', label: 'Contact inbox', icon: Chat, adminOnly: true },
  { to: '/team', label: 'Team', icon: UserMultiple, adminOnly: true },
  { to: '/settings', label: 'Settings', icon: Settings },
];

const DashboardNav = () => {
  const { pathname } = useLocation();
  const { isAdmin } = useAuth();

  return (
    <nav className="dashboard-nav" aria-label="App navigation">
      {navItems
        .filter((item) => !item.adminOnly || isAdmin)
        .map(({ to, label, icon: Icon }) => {
          const isActive = pathname === to || (to !== '/dashboard' && pathname.startsWith(to));

          return (
            <Link
              key={to}
              to={to}
              className={`dashboard-nav__link${isActive ? ' dashboard-nav__link--active' : ''}`}
            >
              <Icon size={16} />
              {label}
            </Link>
          );
        })}
    </nav>
  );
};

export default DashboardNav;
